<template>
  <v-skeleton-loader class="brand-skeleton" v-bind="attrs" />
</template>

<script setup>
import { useAttrs } from 'vue'

const attrs = useAttrs()

defineOptions({ inheritAttrs: false })
</script>

<style lang="scss">
// The ticket asks for the bones at "70% transparent, 30% visible" -- the
// placeholder should hint at the shape without competing with the real content
// that replaces it.
$brand-skeleton-bone-opacity: 0.3;

// Direct children only. Composite types nest a bone per line inside a wrapper
// bone (`paragraph` is `text@3`), so fading every bone multiplies -- 0.3 * 0.3
// put paragraph lines at 9% instead of 30%. Fading just the top level makes one
// compositing group the nested bones inherit, so every bone lands at 0.3.
.brand-skeleton.v-skeleton-loader {
  // Vuetify paints the loader's own surface colour here, which is an opaque
  // theme background. On a tinted surface -- a note detail page carries the
  // note's colour on its content column -- that is a white slab sitting on the
  // colour. Transparent instead, so the placeholder always sits *on* whatever it
  // is loading over, and the bones below read as a shade of that colour rather
  // than of the theme.
  background: transparent;

  > .v-skeleton-loader__bone {
    opacity: $brand-skeleton-bone-opacity;
  }
}
</style>
